export type PreviewableKind = 'image' | 'pdf';

export const getPreviewableKind = (
  mimeType: string,
): PreviewableKind | null => {
  if (mimeType === 'application/pdf') {
    return 'pdf';
  }
  if (mimeType.startsWith('image/')) {
    return 'image';
  }
  return null;
};
